import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { message } from 'antd'
import { equipmentSelector, createEquipmentAction } from '../../../store/equipment'
import EquipmentFormModal from './EquipmentFormModal'

const messageKey = 'add_new_equipment'

const AddEquipmentModal = (props) => {
  const dispatch = useDispatch()
  const { isFetching } = useSelector(equipmentSelector)

  const { onFinish } = props

  const onFinishAction = useCallback(
    async ({ name, serial_number, issue_year, price, description, images }) => {
      const newEquipment = await dispatch(
        createEquipmentAction({ name, serial_number, issue_year, price, description, images })
      ).unwrap()
      message.success({
        key: messageKey,
        content: `Оборудование '${newEquipment?.name}' добавлено успешно`,
      })
      onFinish()
    },
    [dispatch]
  )

  const onErrorAction = useCallback(({ name, status, message: errorMessage }) => {
    message.error({
      key: messageKey,
      content: `Ошибка (${name}, статус: ${status}): '${errorMessage}' `,
    })
  }, [])

  return (
    <EquipmentFormModal
      {...props}
      modalTitle="Новое оборудование на складе"
      formName="new-equipment"
      submitCaption="Добавить"
      isFetching={isFetching}
      onFinish={onFinishAction}
      onError={onErrorAction}
    />
  )
}

export default AddEquipmentModal
